import * as moment from 'moment';

import type Rate from '~/types/Rate';

import { currencies, type Currency } from '~/constants/currency';
import * as APIMessage from '~/types/APIMessage';
import { parcelFromJSON, type JSONParcel, type Parcel } from '~/types/OrdersBatch';
import * as rates from '~/types/Rate';

enum ShipmentStatus {
  COMPLETE = 'COMPLETE',
  ERROR = 'ERROR',
  PENDING = 'PENDING',
  PROCESSING = 'PROCESSING',
  SUCCESS = 'SUCCESS',
}

export type ShipmentObjectId = string;

type JSONShipment = {
  extra: JSONShipmentExtra;
  messages: APIMessage.JSONAPIMessage[];
  object_id: string;
  parcels: JSONParcel[];
  rates: rates.JSONRate[];
  shipment_date: string;
  status: string;
};

type JSONShipmentExtra = {
  insurance?: {
    amount: string;
    currency: string;
  };
  signature_confirmation?: string;
};

// Complete it later
type Shipment = {
  extra?: ShipmentExtra;
  messages: APIMessage.APIMessage[];
  objectId: ShipmentObjectId;
  parcels: Parcel[];
  rates: Rate[];
  shipmentDate: moment.Moment;
  status: ShipmentStatus;
};

type ShipmentExtra = {
  insurance?: {
    amount: string;
    currency: Currency;
  };
  signatureConfirmation?: string;
};

const fromJSON = (jsonShipment: JSONShipment): Shipment => ({
  extra: extraFromJSON(jsonShipment.extra),
  messages: jsonShipment.messages.map(APIMessage.fromJSON),
  objectId: jsonShipment.object_id,
  parcels: jsonShipment.parcels.map(parcelFromJSON),
  rates: jsonShipment.rates.map(rates.fromJSON),
  shipmentDate: moment(jsonShipment.shipment_date),
  status: ShipmentStatus[jsonShipment.status],
});

const extraFromJSON = (jsonExtra?: JSONShipmentExtra) => {
  if (!jsonExtra) return;

  const extra: ShipmentExtra = {
    signatureConfirmation: jsonExtra.signature_confirmation,
  };

  if (jsonExtra.insurance) {
    extra.insurance = {
      amount: jsonExtra.insurance.amount,
      currency: currencies[jsonExtra.insurance.currency],
    };
  }

  return extra;
};

export default Shipment;

export { JSONShipment, ShipmentStatus, fromJSON };
